import axios from "axios";
import axiosConfig from "../axiosConfig.js";

const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

class GoogleMapService {

    fetchAuthcomplete = async (input) => {
        try {
            const response = await axiosConfig.get(`googlemap/place/autocomplete?input=${input}`);
            return response;
        } catch (error) {
            throw new Error(error.response?.data?.message || "no places");
        }
    };

    getPlaceDetails = async (placeId) => {
        try {
            const response = await axiosConfig.get(`googlemap/place/details?id=${placeId}`);
            return response;
        } catch (error) {
            throw new Error(error.response?.data?.message || "no place");
        }
    };
}

const instance = new GoogleMapService();

export default instance;
